var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useEffect, useMemo, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { applyOpenGraphThumbnailSize, classNames, truncateWords } from '@shapeable/utils';
import { useLang } from '../hooks/use-lang';
import { useLink } from '../hooks/use-link';
import { useSiteSearch } from '../hooks/use-site-search';
import { useOrganisations } from '../hooks/use-organisations';
import { usePages } from '../hooks/use-pages';
import { usePeople } from '../hooks/use-people';
import { useSite } from '../hooks/use-site';
import { useSiteSidebar } from '../hooks/use-site-sidebar';
import { useSubTopics } from '../hooks/use-sub-topics';
import { useTopics } from '../hooks/use-topics';
import { useTrends } from '../hooks/use-trends';
import { sprintf } from 'sprintf-js';
import { SearchIconGlyph } from '@shapeable/icons';
import { flatten, map, mapValues, sortBy } from 'lodash';
import { EntityValue } from '../entities/entity-value';
import { useCitations } from '../hooks/use-citations';
import { useFeedEntries } from '../hooks/use-feed-entries';
import { usePosts } from '../hooks/use-posts';
import { useEvents } from '../hooks/use-events';
import { useVideos } from '../hooks/use-videos';
import Highlighter from 'react-highlight-words';
import { useInfiniteScrollArray } from '../hooks/use-infinite-scroll-array';
import { LightMode } from '../context/theme-mode-context';
import { useEconomies } from '../hooks/use-economies';
import { useEntityTypeDynamic } from '../hooks/use-entity-type-dynamic';
var cls = classNames('site-search');
export var SiteSearchDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n    position: fixed;\n    z-index: 1000;\n    height: calc(100vh - 64px);\n    width: 100vw;\n    left: 0;\n    top: 64px;\n    overflow: hidden;\n    box-sizing: border-box;\n    padding: 0;\n    cursor: pointer;\n    // must be 16 to prevent zooming\n    font-size: ", ";\n    color: ", ";\n  "], ["\n    background: ", ";\n    position: fixed;\n    z-index: 1000;\n    height: calc(100vh - 64px);\n    width: 100vw;\n    left: 0;\n    top: 64px;\n    overflow: hidden;\n    box-sizing: border-box;\n    padding: 0;\n    cursor: pointer;\n    // must be 16 to prevent zooming\n    font-size: ", ";\n    color: ", ";\n  "])), theme.COLOR('mid'), theme.FONT_SIZE(12), theme.COLOR('text')),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    top: 0;\n    height: 100vh;\n    padding: ", " ", ";\n    font-size: ", ";\n  "], ["\n    top: 0;\n    height: 100vh;\n    padding: ", " ", ";\n    font-size: ", ";\n  "])), theme.UNIT(20), theme.UNIT(6), theme.FONT_SIZE(14)),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", " ", ";\n    font-size: ", ";\n  "], ["\n    padding: ", " ", ";\n    font-size: ", ";\n  "])), theme.UNIT(24), theme.UNIT(16), theme.FONT_SIZE(16))
});
var LayoutStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    background: ", ";\n    cursor: default;\n    display: flex;\n    flex-direction: column;\n    margin: 0 auto;\n    box-shadow: 0 0 ", " rgba(0, 0, 0, 0.1);\n  "], ["\n    background: ", ";\n    cursor: default;\n    display: flex;\n    flex-direction: column;\n    margin: 0 auto;\n    box-shadow: 0 0 ", " rgba(0, 0, 0, 0.1);\n  "])), theme.COLOR('app-chrome'), theme.UNIT(10)),
  tablet: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    border-radius: ", ";\n  "], ["\n    border-radius: ", ";\n  "])), theme.UNIT(6)),
  desktop: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    border: 1px solid ", ";\n    max-width: 860px;\n  "], ["\n    border: 1px solid ", ";\n    max-width: 860px;\n  "])), theme.COLOR('sub'))
});
var InputContainerStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    padding: ", " ", ";\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  "], ["\n    padding: ", " ", ";\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  "])), theme.UNIT(4), theme.UNIT(5)),
  tablet: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme.UNIT(6))
});
var InputStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin-left: ", ";\n    background: transparent;\n    padding-bottom: 3px;\n    font-size: 1em;\n    border: none;\n    font-family: ", ";\n    outline: none;\n    width: 100%;\n    font-size: 16px;\n  "], ["\n    margin-left: ", ";\n    background: transparent;\n    padding-bottom: 3px;\n    font-size: 1em;\n    border: none;\n    font-family: ", ";\n    outline: none;\n    width: 100%;\n    font-size: 16px;\n  "])), theme.UNIT(3), theme.FONT('sans'))
});
var IconStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ResultsStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    padding-bottom: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    padding-bottom: ", ";\n  "])), theme.UNIT(6))
});
var ItemsStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    overflow-y: auto;\n    overflow-x: hidden;\n    max-height: 70vh;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    ", ";\n  "], ["\n    overflow-y: auto;\n    overflow-x: hidden;\n    max-height: 70vh;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    ", ";\n  "])), theme.DOT_BG('h'))
});
var EntityValueStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    font-size: 1em;\n    padding: ", " ", " 0;\n  "], ["\n    font-size: 1em;\n    padding: ", " ", " 0;\n  "])), theme.UNIT(4), theme.UNIT(4))
});
var ItemStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    background: ", ";\n    cursor: pointer; \n    list-style: none;\n    ", ";\n    ", ";\n    padding-bottom: ", ";\n\n    &:hover {\n      background-color: ", ";\n    }\n    \n    &:last-child {\n    }\n\n    ", "\n\n    .shp--highlight {\n      background-color: transparent;\n      color: ", ";\n    }\n  "], ["\n    background: ", ";\n    cursor: pointer; \n    list-style: none;\n    ", ";\n    ", ";\n    padding-bottom: ", ";\n\n    &:hover {\n      background-color: ", ";\n    }\n    \n    &:last-child {\n    }\n\n    ", "\n\n    .shp--highlight {\n      background-color: transparent;\n      color: ", ";\n    }\n  "])), theme.COLOR('bright'), theme.H_DOT_BG_END(), theme.TRANSITION('filter', 'background-color'), theme.UNIT(4, 2), theme.COLOR('highlight'), function (_a) {
    var isActive = _a.isActive;
    return isActive && css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), theme.COLOR('highlight'));
  }, theme.COLOR('text-highlight'))
});
var DescriptionStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    padding: ", " ", " 0; \n    font-weight: 300;\n  "], ["\n    padding: ", " ", " 0; \n    font-weight: 300;\n  "])), theme.UNIT(4), theme.UNIT(4))
});
var SentryStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    height: 20px;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  "], ["\n    height: 20px;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Layout: styled.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Icon: styled(SearchIconGlyph)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  InputContainer: styled.div(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), InputContainerStyles),
  Input: styled.input(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), InputStyles),
  Sentry: styled.li(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), SentryStyles),
  Results: styled.div(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), ResultsStyles),
  Items: styled.ul(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Item: styled.li(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  EntityValue: styled(EntityValue)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), EntityValueStyles),
  Description: styled.div(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles)
};
export var SiteSearch = function (props) {
  var className = props.className;
  var search = useSiteSearch();
  var sidebar = useSiteSidebar();
  var site = useSite();
  var t = useLang();
  var _a = __read(useState(0), 2),
    cursor = _a[0],
    setCursor = _a[1];
  var navigate = useLink().navigate;
  var dynamicEntities = useEntityTypeDynamic();
  var resultRefs = useRef([]); // Array of refs for each result
  var _b = __read(useState([]), 2),
    results = _b[0],
    setResults = _b[1];
  // pull all data types (need a better way to handle this.)
  // note the order of these determines the order of the search results too currently.
  // it makes sense to have the more specific taxonomy entities first in the list.
  var dict = __assign({
    Trend: useTrends() || [],
    Topic: useTopics() || [],
    SubTopic: useSubTopics() || [],
    Video: useVideos() || [],
    Economy: useEconomies() || [],
    Event: useEvents() || [],
    Post: usePosts() || [],
    Page: usePages() || [],
    Person: usePeople() || [],
    Organisation: useOrganisations() || [],
    FeedEntry: useFeedEntries() || [],
    Citation: useCitations() || []
  }, mapValues(search.extraDataHooks || {}, function (hook) {
    return hook();
  }));
  var entityData = useMemo(function () {
    return mapValues(dict, function (entities) {
      return entities.map(applyOpenGraphThumbnailSize('bubble'));
    });
  }, []);
  var entitySearchRank = {
    Trend: 1,
    Topic: 2,
    SubTopic: 3,
    Page: 4,
    Video: 5,
    Event: 6,
    Post: 7,
    Economy: 7,
    Person: 8,
    Organisation: 900,
    FeedEntry: 1000,
    Citation: 1100
  };
  var inputRef = useRef(null);
  // Effect to scroll the highlighted item into view when cursor changes
  React.useEffect(function () {
    var _a, _b;
    (_b = (_a = resultRefs.current) === null || _a === void 0 ? void 0 : _a[cursor]) === null || _b === void 0 ? void 0 : _b.scrollIntoView({
      // behavior: 'smooth', // Optional, makes the scrolling smooth
      block: 'nearest' // Scrolls only if the item is not fully visible
    });
  }, [cursor]);
  useEffect(function () {
    var handler = setTimeout(function () {
      // search all entities
      if (search.term) {
        var results_1 = sortBy(flatten(map(entityData, function (entities, type) {
          return entities.filter(function (entity) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            entity._searchRank = 0;
            var nameField = (entity.title || entity.name || '').toLowerCase();
            var searchTerm = (_a = search.term) === null || _a === void 0 ? void 0 : _a.toLowerCase();
            var rankModifier = entitySearchRank[type] || 10;
            var description = ((_d = (_c = (_b = entity.openGraph) === null || _b === void 0 ? void 0 : _b.description) === null || _c === void 0 ? void 0 : _c.plain) === null || _d === void 0 ? void 0 : _d.toLowerCase()) || ((_g = (_f = (_e = entity.openGraph) === null || _e === void 0 ? void 0 : _e.description) === null || _f === void 0 ? void 0 : _f.text) === null || _g === void 0 ? void 0 : _g.toLowerCase()) || '';
            if (nameField && nameField.startsWith((_h = search.term) === null || _h === void 0 ? void 0 : _h.toLowerCase())) {
              entity._searchRank = rankModifier;
            } else if (nameField.includes(searchTerm)) {
              entity._searchRank = 200 + rankModifier;
            } else if (description.includes(searchTerm)) {
              entity._searchRank = 500 + rankModifier;
            }
            return !!entity._searchRank;
          });
        })), '_searchRank');
        setResults(results_1);
      } else {
        setResults([]);
      }
    }, 700);
    // Cleanup the timeout if searchTerm changes before delay ends
    return function () {
      clearTimeout(handler);
    };
  }, [search === null || search === void 0 ? void 0 : search.term]);
  if (!search.isVisible) {
    return null;
  }
  var _c = useInfiniteScrollArray({
      all: results,
      itemsPerPage: 6,
      rootMargin: '0px 0px 400px 0px'
    }),
    sentryRef = _c.sentryRef,
    rootRef = _c.rootRef,
    visibleResults = _c.items;
  var handleContainerClick = function (e) {
    e.stopPropagation();
    if (e.target === e.currentTarget) {
      search.hide();
    }
  };
  var handleInputChange = function (e) {
    search.patchTerm(e.target.value);
    setCursor(0);
  };
  var handleEntityClick = function (entity) {
    var entityPath = entity.path;
    search.hide();
    var windowOpen = !!entity.url;
    if (windowOpen) {
      window.open(entity.url);
      return;
    } else {
      navigate(entityPath);
    }
  };
  var handleKeyDown = function (e) {
    if (e.key === 'Escape') {
      search.hide();
    }
    if (e.key === '\\') {
      // Prevent the input of the backslash key
      e.preventDefault();
    }
    if (e.key === 'ArrowUp') {
      // add menu scrolling with arrow keys
      e.preventDefault();
      setCursor(cursor === 0 ? 0 : cursor - 1);
    }
    if (e.key === 'ArrowDown') {
      // add menu scrolling with arrow keys
      e.preventDefault();
      setCursor(Math.min(visibleResults.length - 1, cursor + 1));
    }
    if (e.key === 'Enter') {
      handleEntityClick(visibleResults === null || visibleResults === void 0 ? void 0 : visibleResults[cursor]);
    }
  };
  return React.createElement(LightMode, null, React.createElement(My.Container, {
    onClick: handleContainerClick,
    className: cls.name(className)
  }, React.createElement(My.Layout, {
    sidebarWidth: sidebar.width
  }, React.createElement(My.InputContainer, {
    onClick: function () {
      if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) {
        inputRef.current.focus();
      }
    }
  }, React.createElement(My.Icon, {
    size: 24
  }), React.createElement(My.Input, {
    ref: inputRef,
    onChange: handleInputChange,
    value: search.term,
    placeholder: search.placeholder || sprintf(t('Search %s'), site.name || 'Website'),
    autoFocus: true,
    onKeyDown: handleKeyDown
  })), visibleResults.length > 0 && React.createElement(My.Results, null, React.createElement(My.Items, {
    ref: rootRef
  }, visibleResults.map(function (item, index) {
    var _a, _b, _c, _d;
    var description = ((_b = (_a = item.openGraph) === null || _a === void 0 ? void 0 : _a.description) === null || _b === void 0 ? void 0 : _b.plain) || ((_d = (_c = item.openGraph) === null || _c === void 0 ? void 0 : _c.description) === null || _d === void 0 ? void 0 : _d.text);
    return React.createElement(My.Item, {
      onMouseOver: function () {
        return setCursor(index);
      },
      key: item.id,
      onClick: function () {
        handleEntityClick(item);
      },
      /* @ts-ignore */
      ref: function (el) {
        return resultRefs.current[index] = el;
      },
      isActive: index === cursor
    }, React.createElement(My.EntityValue, {
      highlight: search === null || search === void 0 ? void 0 : search.term,
      name: item.title || item.name,
      entity: item
    }), description && React.createElement(My.Description, null, React.createElement(Highlighter, {
      highlightClassName: 'shp--highlight',
      searchWords: [search === null || search === void 0 ? void 0 : search.term],
      textToHighlight: truncateWords(description, {
        max: 50
      })
    })));
  }), React.createElement(My.Sentry, {
    ref: sentryRef
  }))))));
};
SiteSearch.cls = cls;
SiteSearch.defaultProps = SiteSearchDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28;